import React, { useMemo } from 'react';

import { FixYourAddressWarningCard } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { useMyMoneyStore } from '@/modules/UseMyMoney/stores';
import { UseMyMoneyOption } from '@/modules/UseMyMoney/UseMyMoney.types';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';
import { PaymentMethodType } from '@/modules/user/user.types';

interface Props {
  paymentMethodType?: PaymentMethodType;
}

const FixYourAddressWarningCardWrapper: React.FC<Props> = ({ paymentMethodType }) => {
  const { useMyMoneyOption } = useMyMoneyStore();
  const { employee } = useEmployeeStore();
  const { selectedMethod } = useStore();

  const hasUndeliverableAddress = useMemo(
    () => !!employee?.addresses?.find((address) => address?.undeliverable && address?.preferredMailing),
    [employee?.addresses]
  );

  if (paymentMethodType === PaymentMethodType.CHECK
    && selectedMethod?.type === PaymentMethodType.CHECK
    && useMyMoneyOption === UseMyMoneyOption.REIMBURSE_MYSELF
  ) {
    return <FixYourAddressWarningCard storeKey="fix-your-address-warning-card_payment-methods" showWarning={hasUndeliverableAddress} />;
  }

  return null;
};

export default FixYourAddressWarningCardWrapper;
